import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Container,
  Grid,
  Typography,
} from "@material-ui/core"
import { Link, graphql } from "gatsby"
import { useTranslation } from "react-i18next"

import TitrePage from "../components/titrePage"
import useDisplayDate from "../lib/displayDate"
import logo from "images/logo-wsc.png"

export const query = graphql`
  query projetQuery {
    projets: allSanityProjet(sort: { fields: startDate, order: DESC }) {
      nodes {
        langue
        brief
        startDate
        endDate
        running
        client {
          id
          name
          image {
            asset {
              fixed(height: 50, width: 50) {
                src
              }
            }
          }
        }
        heroImage {
          asset {
            fixed(width: 800, height: 600) {
              src
            }
          }
        }
        id
        name
        slug {
          current
        }
        categories {
          id
          title
        }
      }
    }
  }
`

export default function Projets({ data }) {
  const classes = useStyles()
  const { i18n } = useTranslation()
  const projets = data.projets.nodes

  return (
    <section className={classes.section}>
      <TitrePage titre="menu.projets" />
      <Container>
        <Grid container spacing={2}>
          {projets.map(projet => {
            if (projet.langue !== i18n.language) return null
            return (
              <Grid item sm={12} md={6} lg={4} key={projet.id}>
                <Projet projet={projet} />
              </Grid>
            )
          })}
        </Grid>
      </Container>
    </section>
  )
}

const Projet = ({ projet }) => {
  const { t } = useTranslation()
  const classes = useStyleCard()
  const strDate = useDisplayDate(
    projet.startDate,
    projet.endDate,
    projet.running
  )

  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          projet.client ? (
            <Avatar src={projet.client.image.asset.fixed.src} />
          ) : (
            <Avatar src={logo} />
          )
        }
        title={projet.name}
        subheader={strDate}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardMedia
        className={classes.media}
        image={projet.heroImage.asset.fixed.src}
      />
      <CardContent>
        {projet.categories.map(category => (
          <Chip
            label={category.title}
            color="secondary"
            key={category.id}
            size="small"
            style={{ marginRight: "0.5rem", marginBottom: "1rem" }}
          />
        ))}
        <Typography
          variant="subtitle1"
          color="textSecondary"
          className={classes.ellipsis}
        >
          {projet.brief}
        </Typography>
      </CardContent>
      <CardActions>
        <Button variant="outlined" color="primary">
          <Link to={`/projet/${projet.slug.current}`} className={classes.link}>
            {t("projet.bouton")}
          </Link>
        </Button>
      </CardActions>
    </Card>
  )
}

const useStyles = makeStyles(theme => ({
  section1: {
    flexGrow: 1,
    backgroundColor: theme.palette.bgwhite,
    color: "white",
    margin: "0px auto",
  },
}))

const useStyleCard = makeStyles(theme => ({
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  media: {
    height: 0,
    paddingTop: "56.25%",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:visited": { color: theme.palette.primary.main },
  },
  ellipsis: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
  },
}))
